module.exports = __webpack_public_path__ + "cd455783/img/scraper-icon.df6ccde5.svg";